let backendHost;

const hostname = window && window.location && window.location.hostname;

if (hostname === 'localhost') {
    backendHost = 'http://localhost:9090';
} else if (hostname === 'staff.equals.thewebpeople.ca') {
    backendHost = 'https://staff.equals.thewebpeople.ca';
} else {
    backendHost = 'https://staff.equalsbrewing.com';
}

export const API_ROOT = `${backendHost}/api`;